<template>
  <b-sidebar
    title="Алхмын тохиргоо"
    v-model="showSidebar"
    @change="visibleChanged"
    width="80vw"
  >
    <div class="pd-5 bg-white">
        <button @click="columnOne(0)" long class="btn btn-success btn-block mg-b-10" icon="ios-add">Шинэ</button>
    
      <div style="overflow-y: auto">
        <table class="table-god table table-bordered w-full">
          <thead>
            <tr>
              <th style="width: 40px">№</th>
              <th colspan="2" style="width: 50px">
                <feather type="repeat"></feather>
              </th>
              <th style="min-width: 60px">Хугацаа</th>
              <th style="width: 40px">Алгасах боломж ?</th>
              <th style="width: 40px">Дуусгах боломж ?</th>
              <th style="width: 40px">Тохиргоо</th>
              <th style="min-width: 200px">Алхам</th>
              <th style="min-width:100px">Шууд очих алхам</th>
              <th style="min-width: 400px">-</th>
            </tr>
          </thead>
          <tbody>
            <!-- @click="setCur(c)"  -->
            <tr v-for="(c, i) in columns" :style="{'background': c.checked? 'rgba(0,0,0,0.1)':'inherit'}">
              <td class="text-center">{{i+1}}</td>
              <td style="width: 25px">
                <a @click="changeOrder(c.id,1)">
                  <feather type="arrow-down"></feather>
                </a>
              </td>
              <td style="width: 25px">
                <a @click="changeOrder(c.id,-1)">
                  <feather type="arrow-up"></feather>
                </a>
              </td>
              <td class="text-muted">{{dispTime(c.minute)}}</td>
              <td class="text-center"><feather :type="c.flag=='true'|| c.flag == true ? 'check-square':'square'"></feather></td>
              <td class="text-center"><feather :type="c.isFinishPossible=='true'|| c.isFinishPossible == true ? 'check-square':'square'"></feather></td>
              <td class="text-center">{{c.settingFlag}}</td>
              <td>{{c.title}} 
                <template v-if="c.shortName!=null && c.shortName!=''"> ({{c.shortName}})</template>
              </td>
              <td >
                <span v-if="columns.filter(x=>c.skipAfterColumnId == x.id).length>0">{{columns.filter(x=>c.skipAfterColumnId == x.id)[0].title}}</span>
                <span v-else></span>
              </td>
              <td class="text-center">
                <div size="small" class="btn-group">
                  <button class="btn btn-xs btn-white" @click="shareColumn(c)" icon="ios-people">Хэрэглэгч - {{c.userCount}}</button>
                  <button class="btn btn-xs btn-white" @click="shareBox(c)" icon="md-git-merge">Дэд бүртгэл</button>
                  <button class="btn btn-xs btn-white" @click="columnOne(c.id)" icon="md-options">Засах</button>
                  <button class="btn btn-xs btn-danger" @click="columnDel(c.id)" type="error" icon="md-trash">Устгах</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
</div>


<b-sidebar draggable
      :title="editingColumn.title!=null?editingColumn.title:''"
      :closable="false"
      v-model="editDrawer"
      :width="$store.state.app.isMobile?drwrW:'50vw'"
      :mask-closable="false"
    >
      <Form :model="columnModel" label-width="160px" v-if="modelReady" class="pd-20 bg-white">
        <FormItem label="Алхам">
          <Input v-model="columnModel.col" placeholder="..."></Input>
        </FormItem>
        <FormItem label="Товч нэр">
          <Input v-model="columnModel.shortName" placeholder="..."></Input>
        </FormItem>
        <FormItem label="Алгасах">
          <Select v-model="columnModel.flag">
            <Option :value="0" label="Алгасах боломжгүй"></Option>
            <Option :value="1" label="Алгасах боломжтой"></Option>
          </Select>
        </FormItem>
        <FormItem label="Шууд очих алхам">
          <Select v-model="columnModel.skipAfterColumnId">
            <Option :value="0" label="Тохируулахгүй"></Option>
            <Option
              :key="i"
              v-for="(c, i) in columns.filter(c=>c.id!=editingColumn.id)"
              :value="c.id" :label="c.title"
            ></Option>
          </Select>
        </FormItem>
        <FormItem label="Энэ багана дээрээс дуусгах боломжтой">
          <Select v-model="columnModel.isLastColumn">
            <Option :value="0" label="Үгүй"></Option>
            <Option :value="1" label="Тийм"></Option>
          </Select>
        </FormItem>
        <FormItem label="Алхмын тохиргоо">
          <Select v-model="columnModel.settingFlag" clearable>
            <Option :value="0" label="-"></Option>
            <Option :value="1" label="Цохолттой алхам - 1"></Option>
            <Option :value="2" label="Төсвийн төлөвлөгөө баталгаажуулах алхам - 2"></Option>
            <Option :value="3" label="Төсвийн гүйцэтгэл баталгаажуулах алхам - 3"></Option>

            <Option :value="4" label="Тухайн алхам очиход үүсгэсэн хүнд PINNED share өгөх - 4"></Option>
            <Option :value="5" label="Тухайн алхмаас дараагийн алхамд шилжих үед shared хүмүүсийг хасах - 5"></Option>
            <Option :value="6" label="Зөвхөн хянагч шилжүүлэх үйлдлийг хийх алхам - 6"></Option>
            <Option :value="56" label="5 ба 6 давхар ажиллана - 56"></Option>
          </Select>
        </FormItem>
        <FormItem label="Хугацаа (минутаар)">
          <InputNumber v-model="columnModel.minute"></InputNumber>
          <span class="text-muted m-l-sm">({{dispTime(columnModel.minute)}})</span>
        </FormItem>
        <Divider>Баталж байж дараагийн алхамруу шилжих</Divider>
        <FormItem label="Дор хаяж хэдэн хүн">
          <Select v-model="columnModel.mustAllUserDone">
            <Option :key="`cu_${c}`" v-for="(c) in columnModel.sharedUserCount" :value="c" :label="c"></Option>
            <Option :value="9999" label="Бүх оролцогч"></Option>
          </Select>
        </FormItem>
        <FormItem>
          <button @click="saveColumn(1)" class="btn btn-warning">Хадгалах/ Шинэ</button>
          <button @click="saveColumn()" class="btn btn-primary">Хадгалах/ Хаах</button>
          <button @click="closeEditing()" class="btn btn-danger">Болих</button>
        </FormItem>
      </Form>
    </b-sidebar>

    <mention-users
      :show="projectMention.show"
      :obj.sync="projectMention.obj"
      module="step"
      @on-mention-close="projectMention.show = false; loadColumns()"
    ></mention-users>

    <box-to-column
      :show="sharingBoxDrawerModel.show"
      :taskId="sharingBoxDrawerModel.id"
      :executaFlag="1"
      :sharingModule="6"
      :sharingTitle="sharingBoxDrawerModel.title"
      @on-closed="onBoxColumnClosed"
    ></box-to-column>

  </b-sidebar>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { Form, Input, FormItem, InputNumber, Message ,Select, Option, Divider } from "element-ui";

export default {
    components:{
        Form, Input, FormItem, InputNumber, Message, Select, Option, Divider,

    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    boxToColumn: () => ({
      component: import("@/components/project/boxToColumn.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    },
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    showSidebar: false,
    projectMention:{
      show: false,
    },

    userInfoModal: {
        show: false,
        userId: 0
      },

      columns: [],
      columnDrawer: false,
      editDrawer: false,
      columnModel: {},
      modelReady: false,
      editingColumn: {
        id: 0
      },
      sharingShow: false,
      sharingDrawerTaskModel: {
        id: 0,
        title: "",
        show: false
      },
      sharingBoxDrawerModel:{
        id: 0,
        title: "",
        show: false
      }
  }),
  watch: {
    show: function (newVal) {
      if (newVal) {
        this.init();
      }
    },
  },
  methods: {
    init() {
        this.loadColumns();
      this.showSidebar = true;
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.showSidebar = false;
        this.$emit("on-mention-close");
      }
    },

    columnOne(cid) {
      if (cid > 0) {
        this.columns.filter(x => x.checked === true).forEach(function(e) { e.checked = false; });
        this.columns.filter(c=>c.id==cid)[0].checked=true;

        this.editingColumn =
          this.columns.filter(c => c.id == cid).length > 0
            ? this.columns.filter(c => c.id == cid)[0]
            : "";
      }

      request({
            api: { method: "GET", url: "Column/GetInheritedColumn" },
            params: { projectId: this.obj.id, id: cid },
            store: this.$store
        }).then(res => {
        //console.log(res);
        this.columnModel = res.data.column;
        this.editDrawer = true;
        this.modelReady = true;
      });
    },

    changeOrder(cid, m) {
      request({
        api: { method: "GET", url: "Column/ReOrder" },
        params: { columnId: cid, mode: m },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.loadColumns();
        }
      });
    },
    loadColumns() {

      request({
        api: { method: "GET", url: "Project/PreStep" },
        params: { id: this.obj.id },
        store: this.$store
      }).then(res => {
        //console.log(res, this.obj);
        if(res!=false){
            
            request({
                api: { method: "GET", url: "Column/GetColumnListByProjectId" },
                params: { projectId: this.obj.id },
                store: this.$store
            }).then(res => {
                //console.log(res);
                this.columns = res.data.columns;
                this.columnDrawer = true;
            });
        }
      });

    //   projectPreStep({ id: this.projectId }).then(res => {
    //     if (res != false) {
          
    //     }
    //   });
    },
    dispTime(minutes){
      let rv= '';
      
      if (minutes > 60) {
        if (minutes > 1440) {
          rv = Math.floor(minutes / (24 * 60)) + ' өдөр ' + ((minutes % 24) > 0 ? ((minutes % 24) + ' цаг ' ) : '');
        } else {
          rv = Math.floor(minutes / 60) + ' цаг ' + ((minutes % 60)>0? ((minutes % 60) + ' мин'):'');
        }
      }else{
        rv = minutes + ' мин';
      }

      return rv;
    },
    shareColumn(c) {
      this.columns.filter(x => x.checked === true).forEach(function(e) { e.checked = false; });
      c.checked=true;

      // this.sharingDrawerTaskModel.title = c.title;
      // this.sharingDrawerTaskModel.show = true;
      // this.$nextTick(function(){
      //   this.sharingDrawerTaskModel.id = c.id;
      // })
      this.projectMention.obj= {id: c.id};
      this.projectMention.show= true;

    },
    onBoxColumnClosed(){
      //console.log('onBoxColumnClosed frds');
      this.sharingBoxDrawerModel.id= 0; 
      this.sharingBoxDrawerModel.show= false
    },
    shareBox(c){
      this.columns.filter(x => x.checked === true).forEach(function(e) { e.checked = false; });
      c.checked=true;
      
      this.sharingBoxDrawerModel.title = c.title;
      this.sharingBoxDrawerModel.id = c.id;
      this.$nextTick(function(){
        this.sharingBoxDrawerModel.show = true;  
      })
      
      
    },
    columnDel(cid) {
      if (confirm("Итгэлтэй байна уу?")) {
        request({
                  api: { method: "GET", url: "Column/PreDelete" },
                  params: { id: cid },
                  store: this.$store
              }).then(res => {
          if (res != false) {
            request({
                  api: { method: "POST", url: "Column/Delete" },
                  data: { id: cid },
                  store: this.$store
              }).then(res => {
              if (res != false) {
                this.loadColumns();
                this.$Notice.success({
                  title: "Амжилттай устгалаа",
                  desc: ""
                });
              }
            });
          }
        });
      }
    },

    saveColumn(m) {
      if (this.columnModel.col != null) {
        if (this.columnModel.col.length > 0) {
          request({
                api: { method: "POST", url: "Column/PostInheritedColumn" },
                data: { model: this.columnModel },
                store: this.$store
            }).then(res => {
            if (res != false) {
              this.loadColumns();

              this.modelReady = false;
              this.editDrawer = false;

              if(m!=undefined && m==1) {
                this.columnOne(0);
              }

              this.$Notice.success({
                title: "Амжилттай хадгаллаа",
                desc: ""
              });
            }
          });
        } else {
          this.$Notice.warning({
            title: "Мэдэгдэл",
            desc: "Алхмын нэр заавал бичих шаардлагатай"
          });
        }
      } else {
        this.$Notice.warning({
          title: "Мэдэгдэл",
          desc: "Алхмын нэр заавал бичих шаардлагатай"
        });
      }
    },
    closeEditing() {
      this.modelReady = false;
      this.editDrawer = false;
    },
  },
};
</script>

<style>
</style>